<template>
    <div style="height: 400px;width: 100%">
        <l-map v-if="showMap" :zoom="zoom" :center="center" :options="mapOptions" style="height: 100%" >
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-marker v-for="marker, index in markers" :lat-lng="marker" @click="clickMarker(index)"></l-marker>
        </l-map>
    </div>
</template>

<script>
    import { latLng } from "leaflet";
    import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";

    import { Icon } from 'leaflet';

    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });

    export default {
        name: "Example",
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LPopup,
            LTooltip
        },
        data() {
            return {
                zoom: 16,
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                mapOptions: {zoomSnap: 0.5},
                showMap: true,
            };
        },
        methods: {
            clickMarker(index) {
                this.$store.state.mapclickcount++;
                this.$store.state.mapmarkerclicked = index;
                this.$store.state.mapcentre = this.$store.state.mapmarkers[index];
            },
        },
        computed: {
            center() {
                return this.$store.state.mapcentre;
            },
            markers() {
                return this.$store.state.mapmarkers;
            }
        }
    };
</script>